if (location.protocol !== 'https:') {
  console.log(location.protocol,location.href.substring(location.protocol.length));
	location.replace(`https:${location.href.substring(location.protocol.length)}`);
}

function isItemInCart(itm_id, cartData){
	return cartData.items.find(itm => itm.id == itm_id);
}

function createItmCombination(itm_id, combination_itm_id = false, cartData){  
    if(itm_id && combination_itm_id){
        Object.entries(cartData.attributes).forEach(([key, value]) => {
            let scnd_itm_id = key.replace('combined_item_', '');
          	if(value == combination_itm_id && scnd_itm_id != itm_id){
            	createItmCombination(scnd_itm_id, false, cartData)
            }
        })
   
      	jQuery.post('/cart/update.js', "attributes[combined_item_"+itm_id+"]="+combination_itm_id+"&attributes[combined_item_"+combination_itm_id+"]="+itm_id);	
    } else if(itm_id) {
      	jQuery.post('/cart/update.js', "attributes[combined_item_"+itm_id+"]=false");	
    }
}

function updateCart(e){
    if(e.target.value !== 'select') jQuery('button.update-cart').click();
    if(e.target.value === 'select') window.location.pathname = "/collections/bilder";
}

function removeItmCombination(itm_id){
	jQuery.post('/cart/update.js', "attributes[combined_item_"+itm_id+"]=");	
}

function updateCombination(itm_id, combination_itm_id, cartData){
    if(isItemInCart(itm_id, cartData) && isItemInCart(combination_itm_id, cartData)){
        if(cartData.attributes['combined_item_'+itm_id] != combination_itm_id){
        	createItmCombination(itm_id, combination_itm_id, cartData)
        }
    } else if(isItemInCart(itm_id, cartData)) {
    	createItmCombination(itm_id, false, cartData)
    } else {
      	removeItmCombination(itm_id)
    }
}

function isHolzrahmen(item) {
    if(item.options_with_values.find(o => o.value === 'Mit Bild')){
      return true
    }
}

function isBild(item) {
    if(item.options_with_values.find(o => o.value === 'Holzrahmen')){
      return false
    }
}



function hasCombinationAttr(itm_id, cartData) {
	return cartData.attributes.hasOwnProperty('combined_item_'+itm_id)
}

function setAttributes(data) {
    var combination_items_rahmen = [];
    var combination_items_bild = [];
    data.items.forEach(item => {

      if(item.options_with_values.find(o => o.value === 'Holzrahmen')){
        combination_items_bild.push(item);
      }

      if(item.options_with_values.find(o => o.value === 'Mit Bild')){
        combination_items_rahmen.push(item);
      }

    });


    combination_items_bild.forEach((ci, i) => {
      if(combination_items_rahmen.length >= 1){  
        jQuery.post('/cart/update.js', "attributes[combined_item_"+ci.id+"]="+combination_items_rahmen[i].id);
      } else {
        jQuery.post('/cart/update.js', "attributes[combined_item_"+ci.id+"]=false");
      }
    })


    combination_items_rahmen.forEach((ci, i) => {
      if(combination_items_bild.length >= 1){  
        jQuery.post('/cart/update.js', "attributes[combined_item_"+ci.id+"]="+combination_items_bild[i].id);
      } else {
        jQuery.post('/cart/update.js', "attributes[combined_item_"+ci.id+"]=false");
      }
    })
  
}


function addCombinationOption(productId, title, type) {
  $('#combination-options-'+type+'-select')
    .append('<option value="'+productId+'">'+title+'</option>')
}

function addToCartWithCombination(id, type) {
  let combinationItemId = jQuery('#combination-options-'+type+'-select').val()
  
  jQuery.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      data: {
		items: [
          {
            quantity: 1,
            id: id,
          }
        ]
      }
    })
  .done(function(data){
    jQuery.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      data: "attributes[combined_item_"+combinationItemId+"]="+id+"&attributes[combined_item_"+id+"]="+combinationItemId
    }).done(function(data){
   		window.location.pathname = "/cart"
   	})
  });
  
}


function showMoreOptions(){
  jQuery('#more-options-toggle').hide();
  jQuery('#more-options').show();
}

function showLessOptions(){
  jQuery('#more-options-toggle').show();
  jQuery('#more-options').hide();
}


function avalabilityError(item1, item2){
  jQuery('#availability_error_product_name').html(item1.product_title)
  
  
  itm1_text = document.createTextNode(item1.variant_title);
  itm1_href = "https://galerie-winterberg-erfweiler.de/cart/change?id="+item2.id+"&quantity=0";
  itm1_img = document.createElement('img');
  itm1_img.src = item1.featured_image.url
  jQuery('#availability_error_choice_1').append(itm1_img);   
  jQuery('#availability_error_itm1_title').html(itm1_text);
  jQuery('#availability_error_choice_1').attr('href', itm1_href)
  
  itm2_text = document.createTextNode(item2.variant_title);
  itm2_href = "https://galerie-winterberg-erfweiler.de/cart/change?id="+item1.id+"&quantity=0";
  itm2_img = document.createElement('img');
  itm2_img.src = item1.featured_image.url
  jQuery('#availability_error_choice_2').append(itm2_img);   
  jQuery('#availability_error_itm2_title').html(itm2_text);
  jQuery('#availability_error_choice_2').attr('href', itm2_href)
  
  
  jQuery('#availability_error_product_name').html(item1.product_title)
  jQuery('#availability_error_message').show();
}

async function addToCartAndCombine(id, type) {
  await jQuery.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      data: {
		items: [
          {
            quantity: 1,
            id: id,
          }
        ]
      }
    })
  .done(function(data){ 
    if(type === 'Mit Bild'){
      	
   		window.location.pathname = "/collections/bilder"
    }
    if(type === 'Holzrahmen'){
   		window.location.pathname = "/collections/holzrahmen/gross"
    }
  });
}


$( document ).ready(function() {
      if ($('#ProductSelect-option-rahmen-Holzrahmen').is(':checked')) {
        // If 'ProductSelect-option-rahmen-Holzrahmen' is selected, hide 'ProductSelect-option-1'
        $('#ProductSelect-option-1').hide();
        $('label[for="ProductSelect-option-1"]').hide(); // Hide the label
        $('label[for="ProductSelect-option-grosse-Angepasst"]').show(); // Hide the label
    } else {
        // If 'ProductSelect-option-rahmen-Holzrahmen' is not selected, show 'ProductSelect-option-1'
        $('#ProductSelect-option-1').show();
        $('label[for="ProductSelect-option-1"]').show(); // Hide the label
        $('label[for="ProductSelect-option-grosse-Angepasst"]').hide(); // Hide the label
    }
  $('input[type=radio][name=option2]').change(function() {
    if ($('#ProductSelect-option-rahmen-Holzrahmen').is(':checked')) {
        // If 'ProductSelect-option-rahmen-Holzrahmen' is selected, hide 'ProductSelect-option-1'
        $('#ProductSelect-option-1').hide();
        $('label[for="ProductSelect-option-1"]').hide(); // Hide the label
        $('label[for="ProductSelect-option-grosse-Angepasst"]').show(); // Hide the label
    } else {
        // If 'ProductSelect-option-rahmen-Holzrahmen' is not selected, show 'ProductSelect-option-1'
        $('#ProductSelect-option-1').show();
        $('label[for="ProductSelect-option-1"]').show(); // Hide the label
        $('label[for="ProductSelect-option-grosse-Angepasst"]').hide(); // Hide the label
    }
});
  
  jQuery("#index-down").click(function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#shopify-section-featured-collections").offset().top
    }, 2000);
  });
  
  jQuery("input[type=radio][name='option1']").change(function() {
    
    if(this.value == "Holzrahmen"){
    	jQuery("input[type='radio'][name='option2'][value='Angepasst']").first().click();
    } else {
        jQuery("input[type='radio'][name='option2'][value='21x29.7']").first().click();
    }
    
    if(this.value.includes('Mit Bild')){
      jQuery('#AddToCart--product-template > span').html("Bild auswählen")
    } else if(this.value.includes('Holzrahmen')) {
      jQuery('#AddToCart--product-template > span').html("Holzrahmen auswählen")        
    } else {
      jQuery('#AddToCart--product-template > span').innerHtml = "In den Warenkorb legen"
    }
    

    return true;
  });
  
  
  jQuery('#AddToCartForm--product-template').submit(async function( event ) {
    
    let formData = jQuery('#AddToCartForm--product-template').serializeArray()
    let id = formData.find(d => d.name==="id").value
    let option1 = formData.find(d => d.name==="option1").value
    
    if(option1.includes('Mit Bild')){
      	event.preventDefault();
      	await addToCartAndCombine(id ,option1)
    }
    if(option1.includes('Holzrahmen')){
      	event.preventDefault();
        await addToCartAndCombine(id ,option1)
    }
    
  });
  
  jQuery.ajax({
      url: '/cart/update.js',
      dataType: 'json'
    })
    .done(function(data1){
      let shouldShowCombinationOptions = false
      let cartItems = {}
      let product_ids = {}
      data1.items.forEach((item) => {
        if(!product_ids[item.product_id]){
        	product_ids[item.product_id] = item
        } else if(item.variant_options.includes('Ohne Bild') || item.variant_options.includes('Mit Spiegel') || item.variant_options.includes('Mit Bild')) {
          	avalabilityError(item, product_ids[item.product_id])
        }
        
        if(item.product_title.includes('Holzrahmen') && item.quantity > 1){
          //window.location = "https://galerie-winterberg.myshopify.com/cart/change?id="+item.id+"&quantity=1"
        }
          
          
        if(item.options_with_values.find(o => o.value === 'Holzrahmen' || o.value === 'Mit Bild') ){
        	if(!hasCombinationAttr(item.id, data1)){
        		updateCombination(item.id, false, data1)
        	}
          	let type = isHolzrahmen(item) ? 'rahmen' : 'bild'
            
            Object.entries(data1.attributes).forEach(([key, value]) => {
          		if(key === "combined_item_"+item.id && (value == 'false' || !value)){
                	addCombinationOption(item.id, item.product_title, type)
                }
            })
            
            cartItems[item.id] = item
        }
        
      })

      Object.entries(data1.attributes).forEach(([key, value]) => {
          if(key.includes("combined_item_")){
            let itm_id = key.replace('combined_item_', '');
            let combination_itm_id = value;
            updateCombination(itm_id, combination_itm_id, data1);
			cartItems[itm_id]['combination'] = combination_itm_id
          }
      })
      
      
      let path = window.location.pathname.split('/')
      if(path.includes('products')){
        let productHandle = path[path.findIndex(p => p === 'products')+1]
        if(productHandle){
          jQuery.getJSON('/products/'+productHandle+'.js', function(product) {
            if(product.options.findIndex(po => po.name === 'Rahmen') >= 0){
              if(Object.values(cartItems).find(ci => ci.combination === 'false' && ci.variant_title.includes('Mit Bild'))){
                jQuery('#combination-options-bild').hide()
              	jQuery('#combination-options-rahmen').show()
                showLessOptions();
              } else {
              	jQuery('#combination-options-rahmen').hide()
                jQuery('#combination-options-bild').hide()
              }
            } else if (product.options.findIndex(po => po.name === 'Bild') >= 0) {
              if(Object.values(cartItems).find(ci => ci.combination === 'false' && ci.variant_title.includes('Holzrahmen'))){
                jQuery('#combination-options-rahmen').hide()
                jQuery('#combination-options-bild').show()
                showLessOptions();
              }else {
                jQuery('#combination-options-bild').hide()
                jQuery('#combination-options-rahmen').hide()
              }
            }
          });
        }
      }
         

  	});
  

  
  
});